import React, { useEffect, useState } from 'react';

import { Divider, Spinner } from '@telus-uds/components-web';

import { TopBarContainer } from './css';
import request from '../../../utils/request';

import Filter from './components/filter';
import Block from './components/block';

const Channels = () => {
  const [apiData, setApiData] = useState();
  const [filterString, setFilterString] = useState('');

  const fetchData = async () => {
    try {
      const result = await request.get('/channels/?type=1');

      if (result && result.status === 200) {
        setApiData(result.data.channels);
      }
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Divider space={3} variant={{ inverse: true }} />
      {!apiData && <Spinner show label="Loading data..." />}
      {apiData && (
        <>
          <TopBarContainer>
            <Filter
              filterString={filterString}
              setFilterString={setFilterString}
            />
          </TopBarContainer>
          <Divider space={3} variant={{ inverse: true }} />
          <Block
            data={apiData}
            filterString={filterString}
            fetchData={fetchData}
          />
        </>
      )}
    </>
  );
};

export default Channels;
